<template>
  <div>
    <b-form-group
      label="Tutar"
      label-for="amount"
    >
      <validation-provider
        #default="{ errors }"
        name="Tutar"
        rules="required"
      >
        <b-input-group append="₺">
          <cleave
            id="amount"
            v-model="dataItem.amount"
            class="form-control"
            :raw="true"
            :options="options.number"
            placeholder="Tutar"
          />
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BInputGroup } from 'bootstrap-vue'
import { required } from '@core/utils/validations/validations'
import Cleave from 'vue-cleave-component'

export default {
  name: 'AmountCard',
  components: {
    BInputGroup, BFormGroup, ValidationProvider, Cleave,
  },
  data() {
    return {
      required,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['paymentCollections/dataItem']
    },
  },
}
</script>
